/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { DropReferralEntry } from './DropReferralEntry';
import {
    DropReferralEntryFromJSON,
    DropReferralEntryFromJSONTyped,
    DropReferralEntryToJSON,
    DropReferralEntryToJSONTyped,
} from './DropReferralEntry';

/**
 * 
 * @export
 * @interface DropReferralStatsResponse
 */
export interface DropReferralStatsResponse {
    /**
     * 
     * @type {number}
     * @memberof DropReferralStatsResponse
     */
    referralCount: number;
    /**
     * 
     * @type {Array<DropReferralEntry>}
     * @memberof DropReferralStatsResponse
     */
    referrals: Array<DropReferralEntry>;
    /**
     * 
     * @type {PaginationInfo}
     * @memberof DropReferralStatsResponse
     */
    paginationInfo: PaginationInfo;
}

/**
 * Check if a given object implements the DropReferralStatsResponse interface.
 */
export function instanceOfDropReferralStatsResponse(value: object): value is DropReferralStatsResponse {
    if (!('referralCount' in value) || value['referralCount'] === undefined) return false;
    if (!('referrals' in value) || value['referrals'] === undefined) return false;
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    return true;
}

export function DropReferralStatsResponseFromJSON(json: any): DropReferralStatsResponse {
    return DropReferralStatsResponseFromJSONTyped(json, false);
}

export function DropReferralStatsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropReferralStatsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'referralCount': json['referralCount'],
        'referrals': ((json['referrals'] as Array<any>).map(DropReferralEntryFromJSON)),
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
    };
}

export function DropReferralStatsResponseToJSON(json: any): DropReferralStatsResponse {
    return DropReferralStatsResponseToJSONTyped(json, false);
}

export function DropReferralStatsResponseToJSONTyped(value?: DropReferralStatsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'referralCount': value['referralCount'],
        'referrals': ((value['referrals'] as Array<any>).map(DropReferralEntryToJSON)),
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
    };
}

